export const orderSearchesElements = (data, labelKey = 'element') => {
  if (!Array.isArray(data)) return [];

  const order = ['SIT', 'Novice', 'Advanced', 'Excellent', 'Premier'];

  const getCategory = (label) => {
    return order.find(category => label.includes(category)) || '';
  };

  const compareElements = (a, b) => {
    if (a[labelKey] === 'Birch SIT') return -1;
    if (b[labelKey] === 'Birch SIT') return 1;

    const aCategory = getCategory(a[labelKey]);
    const bCategory = getCategory(b[labelKey]);

    const categoryComparison = order.indexOf(aCategory) - order.indexOf(bCategory);

    if (categoryComparison === 0) {
      return a[labelKey].localeCompare(b[labelKey]);
    }

    return categoryComparison;
  };

  return [...data].sort(compareElements);
};
